"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummonReaperAbilityHandler = exports.SummonReaperActorAbilityFactory = exports.SummonReaperAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const __1 = require("../..");
const ActorArgs_1 = require("../../core/actors/ActorArgs");
const ActorType_1 = require("../../core/actors/ActorType");
class SummonReaperAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.SummonReaper;
        this.__typeName = "SummonReaper";
    }
}
exports.SummonReaperAbilityArgs = SummonReaperAbilityArgs;
let SummonReaperActorAbilityFactory = class SummonReaperActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("SummonReaper", "Self", 1);
    }
};
SummonReaperActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("SummonReaper")
], SummonReaperActorAbilityFactory);
exports.SummonReaperActorAbilityFactory = SummonReaperActorAbilityFactory;
let SummonReaperAbilityHandler = class SummonReaperAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const invoker = container.getActor(ability.invokerId);
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                const reaperArgs = new ActorArgs_1.NpcActorArgs(invoker.faction, ActorType_1.ActorType.NecromancerReaper, invoker.level, 
                // attributes...
                Object.entries(invoker.maxAttributeValues).reduce((pet, [key, value]) => {
                    let multiplier = 1;
                    switch (+key) {
                        case __1.AttributeType.Power:
                            value = (0, __1.getValueOrDefault)(invoker.maxAttributeValues, __1.AttributeType.Focus, 0);
                            break;
                        case __1.AttributeType.Focus:
                            value = (0, __1.getValueOrDefault)(invoker.maxAttributeValues, __1.AttributeType.Power, 0);
                            break;
                    }
                    pet[key] = Math.round(value * multiplier);
                    return pet;
                }, {}), {
                    [__1.AbilitySlot.Ability1]: Registries_1.ActorAbilities.getItem("Reap").mk(),
                })
                    .withPlayerId(invoker.playerId);
                container.summonCompanion(sequence, ability.invokerId, reaperArgs);
                if (container.hasAttribute(ability.invokerId, "Charm_Necromancer_1")) {
                    container.summonCompanion(sequence, ability.invokerId, reaperArgs);
                }
            }
        });
    }
};
SummonReaperAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.SummonReaper)
], SummonReaperAbilityHandler);
exports.SummonReaperAbilityHandler = SummonReaperAbilityHandler;
